export default __webpack_public_path__ + "static/media/angbao-bonus-mooncake.05869ff6.webp";